<script setup>
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import { ref } from "vue";

const sliderOptions = {
  rewind: true,
  type: "slide",
  perPage: 1,
  autoplay: true,
  pagination: true,
  arrows: false,
  padding: "0px",
  focus: "center",
  autoWidth: false,
  direction: "ttb", // This makes it slide vertically (top to bottom)
  height: "400px", // Set fixed height for vertical sliding
  classes: {
    pagination: "splide__pagination splide__pagination_circle",
  },
  breakpoints: {
    992: {
      direction: false,
      height: "auto",
    },
    640: {
      direction: false,
      height: "auto",
      classes: {
        pagination:
          "splide__pagination splide__pagination_circle splide__pagination_mobile",
      },
    },
  },
};

const coachBenefits = ref([
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1757967479/Become_a_Coach/BrandRecognition_nxu5u6.png',
        heading: 'Why You\'ll Love Coaching',
        title: 'BRAND RECOGNITION',
        description: 'Get instant credibility backed by a national brand'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1757967505/Become_a_Coach/ExpertClassPlans_w33qfw.png',
        heading: 'Why You\'ll Love Coaching',
        title: 'EXPERT CLASS PLANS',
        description: 'Focus on great coaching, not lesson planning'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1757967508/Become_a_Coach/Extra_Income_c3mc8m.png',
        heading: 'Why You\'ll Love Coaching',
        title: 'EXTRA INCOME',
        description: 'Get paid for teaching classes and earn commission on product sales'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1757967515/Become_a_Coach/FlexibleScheduling_h8u0ij.png',
        heading: 'Why You\'ll Love Coaching',
        title: 'FLEXIBLE SCHEDULING',
        description: 'Teach kickboxing classes anywhere, anytime'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1757967518/Become_a_Coach/InnovativeTech_otqyp9.png',
        heading: 'Why You\'ll Love Coaching',
        title: 'MAKE AN IMPACT',
        description: 'Help members transform their fitness, confidence, and lives'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1757967521/Become_a_Coach/OnlineVisibility_sg0rrv.png',
        heading: 'Why You\'ll Love Coaching',
        title: 'ONLINE VISIBILITY',
        description: 'Attract clients with a local listing on our national ILKB website'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1757967524/Become_a_Coach/WholesaleEquipment_j5ly0k.png',
        heading: 'Why You\'ll Love Coaching',
        title: 'WHOLESALE EQUIPMENT',
        description: 'Unlock special rates on fitness gear to boost resale opportunities'
    },
    {
        image_link: 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1757967527/Become_a_Coach/WorldClassSupport_zmsybh.png',
        heading: 'Why You\'ll Love Coaching',
        title: 'WORLD-CLASS SUPPORT',
        description: 'Access to expert guidance, ongoing training, and a dedicated support team'
    }
]);
</script>

<template>
  <!-- Why Coach Section -->
  <section class="why-coach-section">
    <div class="container">
      <h2 class="section-title">
        WHY <span class="red-text">C.O.A.C.H.</span>?
      </h2>
      <p class="section-description">
        Becoming an ILKB COACH isn't just a job—it's a chance to turn
        <span class="highlight"
          >your love of fitness into a rewarding career</span
        >. Inspire others, make an impact, and earn extra income
        <span class="highlight">while doing what you love</span>.<br /> Whether
        you're looking for a full-time career or a flexible side hustle,
        coaching gives you the
        <span class="brand-red"
          >tools, training, and community to succeed</span
        >.
      </p>

      <!-- Scribble Divider -->
      <div class="scribble-divider">
        <img src="https://res.cloudinary.com/ilovekickboxing/image/upload/v1758736563/gold_scribble_resized_pkpjzh.png" alt="Gold Scribble Divider">
      </div>

      <Splide :options="sliderOptions" class="coach-carousel">
        <SplideSlide v-for="(benefit, index) in coachBenefits" :key="index">
          <div class="coach-benefits">
            <div class="benefit-image">
              <img :src="benefit.image_link" :alt="benefit.title" />
            </div>
            <div class="benefit-card">
              <h3>{{ benefit.heading }}</h3>
              <h2>{{ benefit.title }}</h2>
              <p>{{ benefit.description }}</p>
            </div>
          </div>
        </SplideSlide>
      </Splide>
    </div>
  </section>
</template>

<style lang="scss" scoped>
// Why Coach Section
.why-coach-section {

  color: white;
  padding: 4rem 0;
  overflow-x: hidden;

  .section-title {
    font-size: 3rem;
    font-weight: bold;
    margin-bottom: 2rem;
    text-align: left; // Changed: Left align the heading
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;

    .red-text {
      color: #ff3b3f;
    }
  }

  .section-description {
    font-size: 1.4rem; // Increased font size to match design
    line-height: 1.8;
    margin-bottom: 3rem;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    text-align: left; // Changed: Left align the paragraph
    color: #ffffff; // Changed: Use white text like in image

    // Add colored text highlights like in the image
    span.highlight {
      color: #c5a254; // Golden yellow for highlighted text
    }

    // Brand red for "tools, training, and community to succeed"
    span.brand-red {
      color: #ff3b3f; // Brand red color
    }
  }

  .coach-carousel {
    position: relative;
    max-width: 800px;
    margin: 0 auto;

    .coach-benefits {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0;
      align-items: stretch;
      height: 400px;

      .benefit-image {
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 0;
        }
      }

      .benefit-card {
        background-color: #ff3b3f;
        padding: 2rem;
        border-radius: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;

        h3 {
          font-size: 2.3rem;
          margin-bottom: 0.5rem;
          font-weight: normal;
          font-style: italic;
          color: white;
          font-family: "Brush Script MT", "cursive", sans-serif; // Handwritten script font
          line-height: 1.2;
        }

        h2 {
          font-size: 2.2rem;
          margin: 0.5rem 0 1rem 0;
          font-weight: 900; // Extra bold
          color: white;
          font-family: "Arial Black", Arial, sans-serif; // Bold sans-serif
          letter-spacing: 1px;
          text-transform: uppercase;
          line-height: 1.1;
        }

        p {
          font-size: 1rem;
          line-height: 1.4;
          margin: 0;
          color: white;
          font-family: Arial, sans-serif;
          font-weight: normal;
        }
      }
    }
  }
}

// Add this to your existing CSS
.scribble-divider {
  text-align: left;
  margin: -50px 0 1rem 0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  img {
    max-width: 200px;
    height: auto;
  }
}

// Base pagination styling
:deep(.splide__pagination button) {
  width: 12px !important;
  height: 12px !important;
  border-radius: 50% !important;
  background: rgba(255, 255, 255, 0.4) !important;
  opacity: 1 !important;
  transition: all 0.3s ease !important;
  border: none !important;
  margin: 0 !important;

  &.is-active {
    background: #ff3b3f !important;
    transform: scale(1.2) !important;
  }
}

// Desktop - vertical dots on the right (FIXED)
@media (min-width: 993px) {
  :deep(.splide__pagination) {
    position: absolute !important;
    right: -60px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 15px !important;
    z-index: 10;
    width: auto !important; // Prevent wrapping
    flex-wrap: nowrap !important; // Force single column
    align-items: center !important; // Center the dots
  }

  .why-coach-section .container {
    position: relative;
    padding-right: 100px;
  }
}

// Mobile - horizontal dots at bottom
@media (max-width: 992px) {
  :deep(.splide__pagination) {
    position: relative !important;
    right: auto !important;
    top: auto !important;
    transform: none !important;
    display: flex !important;
    flex-direction: row !important; // Horizontal on mobile
    justify-content: center !important;
    gap: 15px !important;
    margin-top: 20px !important;
    z-index: 10;
  }

  .why-coach-section {
    .container {
      padding-right: 1rem; // Reset padding on mobile
    }

    .coach-carousel {
      height: auto !important; // Auto height on mobile

      .coach-benefits {
        grid-template-columns: 1fr !important; // Stack vertically
        height: auto !important;

        .benefit-image img {
          height: 250px !important; // Fixed image height
        }
      }
    }
  }
}

// Global overflow fix
* {
  box-sizing: border-box;
}
</style>